module.exports = __webpack_public_path__ + "img/sAztecGolT_350x350.8133ea5a.jpg";